import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router';
import { Sidebar } from './Sidebar';
import { BottomNav } from './BottomNav';
import { MobileHeader } from './MobileHeader';
import { SessionTimeoutModal } from '../auth/SessionTimeoutModal';
import { FileSearch } from '../files/FileSearch';
import { TrialBanner } from './TrialBanner';
import { useAuth } from '../../contexts/AuthContext';

export function Layout() {
  const navigate = useNavigate();
  const { sessionExpiresAt, extendSession } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleUploadClick = () => {
    // Navigate to folders page where upload functionality lives
    navigate('/folders');
  };

  const handleMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      {/* Desktop sidebar - hidden on mobile */}
      <div className="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0">
        <Sidebar />
      </div>

      {/* Main content area with sidebar offset on desktop */}
      <div className="flex-1 flex flex-col lg:pl-64">
        {/* Mobile header - visible on mobile only */}
        <MobileHeader
          isMenuOpen={isMobileMenuOpen}
          onMenuToggle={handleMenuToggle}
        />

        {/* Trial banner */}
        <TrialBanner />

        {/* Desktop header with search - hidden on mobile */}
        <header className="hidden lg:flex h-14 border-b border-gray-200 bg-white px-4 items-center justify-between shrink-0">
          <div className="flex-1 max-w-md">
            <FileSearch />
          </div>
        </header>

        {/* Main content - add bottom padding for mobile nav */}
        <main className="flex-1 overflow-auto pb-20 lg:pb-0">
          <Outlet />
        </main>

        {/* Mobile bottom navigation */}
        <BottomNav
          onUploadClick={handleUploadClick}
          onMenuClick={handleMenuToggle}
        />
      </div>

      {/* Session timeout warning modal */}
      {sessionExpiresAt && (
        <SessionTimeoutModal
          expiresAt={sessionExpiresAt}
          onExtend={extendSession}
        />
      )}
    </div>
  );
}
